'use client'

import { useState } from 'react'
import { Button } from '@/components/ui/button'
import { Card, CardContent } from '@/components/ui/card'
import { Field, FieldContent, FieldLabel, FieldTitle } from '@/components/ui/field'
import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group'

function daysAheadAt(daysAhead: number, hour: number, minute: number): Date {
  const d = new Date()
  d.setDate(d.getDate() + daysAhead)
  d.setHours(hour, minute, 0, 0)
  return d
}

/** Tomorrow + day-after-tomorrow (not tomorrow + next Thursday) — matches the same 24-48h
 * callback window used by the public funnel's own slot picker (`submission-successful-view.tsx`).
 * Each label resolves to a real target `Date` (computed fresh per render, not baked into a stored
 * constant), since `onConfirm` hands the real ISO datetime to `PATCH .../consultation-slot`. */
const SLOTS: { label: string; at: () => Date }[] = [
  { label: 'Tomorrow, 10:00 AM', at: () => daysAheadAt(1, 10, 0) },
  { label: 'Tomorrow, 2:30 PM', at: () => daysAheadAt(1, 14, 30) },
  { label: 'Day after tomorrow, 10:00 AM', at: () => daysAheadAt(2, 10, 0) },
  { label: 'Day after tomorrow, 2:30 PM', at: () => daysAheadAt(2, 14, 30) },
]

export function SlotStep({ onConfirm }: { onConfirm: (consultationSlotAt: string) => void }) {
  const [label, setLabel] = useState<string | null>(null)

  const handleConfirm = () => {
    const picked = SLOTS.find((s) => s.label === label)
    if (picked) onConfirm(picked.at().toISOString())
  }

  return (
    <Card>
      <CardContent className="flex flex-col gap-4 py-6">
        <p className="text-sm font-semibold">Preferred callback time</p>
        <RadioGroup
          value={label ?? undefined}
          onValueChange={setLabel}
          className="grid grid-cols-1 gap-3 sm:grid-cols-2"
        >
          {SLOTS.map((s) => (
            <FieldLabel key={s.label} htmlFor={s.label}>
              <Field orientation="horizontal">
                <RadioGroupItem id={s.label} value={s.label} />
                <FieldContent>
                  <FieldTitle>{s.label}</FieldTitle>
                </FieldContent>
              </Field>
            </FieldLabel>
          ))}
        </RadioGroup>
        <Button className="w-full" onClick={handleConfirm} disabled={!label}>
          Confirm time slot
        </Button>
      </CardContent>
    </Card>
  )
}
